module.exports = __webpack_public_path__ + "img/Shirt.784198ee.svg";